import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StCard = styled.div`
  ${({ theme }) => `
    position: relative;
    background-color: ${theme.Components.Card.Fill};
    border: 1px solid ${theme.Components.Card.Border};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    padding: ${theme.UI.SpacingPx.Space4};
    gap: ${theme.UI.SpacingPx.Space3};

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media ${breakpoints.s} {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: ${theme.UI.SpacingPx.Space6};
      gap: ${theme.UI.SpacingPx.Space6};
        border-width: 2px;
    }
  `}
`

const StImageContainer = styled.div`
  width: 170px;
  height: 150px;
  padding: 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.Colors.Neutrals.Lighter};
  align-items: center;
  justify-content: center;
  display: flex;
`

const StChevron = styled.div`
  ${({ theme }) => `
    position: absolute;
    bottom: ${theme.UI.SpacingPx.Space6};
    right: ${theme.UI.SpacingPx.Space6};
  `}
`

export { StCard, StChevron, StImageContainer }
